import axiosClient from './axiosClient';

export const customerService = {
    // ==========================================
    // 1. QUẢN LÝ HỒ SƠ & MẬT KHẨU
    // ==========================================
    getProfile: () => axiosClient.get('/customer/profile'),
    updateProfile: (data) => axiosClient.put('/customer/profile', data),
    changePassword: (data) => axiosClient.put('/customer/password', data),

    // ==========================================
    // 2. QUẢN LÝ SỔ ĐỊA CHỈ
    // ==========================================
    getAddresses: () => axiosClient.get('/customer/addresses'),
    createAddress: (data) => axiosClient.post('/customer/addresses', data),
    updateAddress: (id, data) => axiosClient.put(`/customer/addresses/${id}`, data),
    deleteAddress: (id) => axiosClient.delete(`/customer/addresses/${id}`),

    // ==========================================
    // 3. QUẢN LÝ ĐƠN HÀNG (MUA HÀNG & CÁ NHÂN)
    // ==========================================
    
    // 👉 THÊM DÒNG NÀY ĐỂ ĐẶT HÀNG ĐƯỢC
    createOrder: (orderPayload) => axiosClient.post('/orders/checkout', orderPayload),
    
    getMyOrders: () => axiosClient.get('/orders/my-orders'),
    cancelOrder: (orderId) => axiosClient.put(`/orders/${orderId}/cancel`),
    updateOrderPaymentMethod: (orderId, paymentMethodId) => axiosClient.put(`/orders/${orderId}/payment-method?paymentMethodId=${paymentMethodId}`),
    updateOrderDeliveryInfo: (orderId, data) => axiosClient.put(`/orders/${orderId}/delivery-info`, data),
    
    // ==========================================
    // Tiện ích lấy danh sách thanh toán
    // ==========================================
    getPublicPaymentMethods: () => axiosClient.get('/public/payment-methods')
};